<template>
  <v-dialog
    v-model="dialog"
    max-width="1200"
    scrollable
    :fullscreen="isMobile()"
  >
    <v-card>
      <template v-if="cargaSelec">
        <v-card-title class="primary white--text"
          >{{ cargaSelec.descricao }} <v-spacer></v-spacer>
          <v-chip small class="font-weight-bold"
            >ID: {{ cargaSelec.id }}</v-chip
          >
          <v-btn icon @click="dialog = false" class="ml-2" large color="white"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-card-subtitle>
          <v-chip class="font-weight-bold mt-2"
            >{{ cargaSelec.placa != "" ? cargaSelec.placa : cargaSelec.status }}
            <chip-prioridade-form-carga
              xsmall
              :prioridade="cargaSelec.prioridade"
            />
          </v-chip>
        </v-card-subtitle>
      </template>
      <v-card-text>
        <carregando-padrao v-if="carregando" />
        <template v-else>
          <v-row dense v-if="cargaSelec.permite_programar_carga">
            <v-col>
              <btn-programar-carga />
            </v-col>
          </v-row>
          <v-row dense>
            <v-col xl="4" lg="4" md="4" cols="12">
              <v-list-item
                dense
                class="rounded-lg grey lighten-4"
                :class="{ 'mb-2': !isMobile() }"
              >
                <v-list-item-content>
                  <v-list-item-title>Status</v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                  <v-chip
                    :style="JSON.parse(cargaSelec.status_css)"
                    x-small
                    class="caption ml-5"
                    >{{ cargaSelec.status }}</v-chip
                  >
                </v-list-item-action>
              </v-list-item>
            </v-col>
            <v-col xl="4" lg="4" md="4" cols="12">
              <v-list-item
                dense
                class="rounded-lg grey lighten-4"
                :class="{ 'mb-2': !isMobile() }"
              >
                <v-list-item-content>
                  <v-list-item-title
                    >Carregamento a partir de</v-list-item-title
                  >
                </v-list-item-content>
                <v-list-item-action>
                  <span class="font-weight-bold">{{
                    formatarProgCarreg(cargaSelec.data_hora_prog_carreg)
                  }}</span>
                </v-list-item-action>
              </v-list-item>
            </v-col>
            <v-col xl="4" lg="4" md="4" cols="12">
              <v-list-item dense class="rounded-lg grey lighten-4 mb-2">
                <v-list-item-content>
                  <v-list-item-title>Formação realizada por</v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                  <span class="font-weight-bold">{{ cargaSelec.usuario }}</span>
                </v-list-item-action>
              </v-list-item>
            </v-col>
          </v-row>

          <distribuir-caixas-form-carga />
        </template>
      </v-card-text>

      <v-card-actions v-if="isMobile()">
        <v-btn rounded block @click="dialog = false" color="secondary"
          >Fechar</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import moment from "moment";
import { mapActions, mapMutations, mapState } from "vuex";
import CarregandoPadrao from "../tela/CarregandoPadrao.vue";
import DistribuirCaixasFormCarga from "./DistribuirCaixasFormCarga.vue";
import ChipPrioridadeFormCarga from "./ChipPrioridadeFormCarga.vue";
import BtnProgramarCarga from "./BtnProgramarCarga.vue";

export default {
  components: {
    DistribuirCaixasFormCarga,
    CarregandoPadrao,
    ChipPrioridadeFormCarga,
    BtnProgramarCarga,
  },
  watch: {
    dialog: async function (open) {
      if (!open) {
        this.setVerDetalhes(false);
        this.$router.go(-1);
      }
    },
  },
  computed: mapState("formacaoCarga", ["cargas", "cargaSelec", "id_carga"]),
  data: () => ({
    carregando: true,
    dialog: false,
  }),
  methods: {
    ...mapMutations("formacaoCarga", [
      "setIdCarga",
      "setCarga",
      "setVerDetalhes",
    ]),
    ...mapActions("formacaoCarga", ["buscarVeiculo"]),
    formatarData(value) {
      return moment(value).format("DD/MM/yyyy");
    },
    formatarProgCarreg(value) {
      moment.locale("pt-Br");
      return moment(value).calendar();
    },
    isMobile() {
      return this.$mq == "sm";
    },
  },
  async mounted() {
    this.dialog = true;
    this.carregando = true;
    this.setVerDetalhes(true);
    this.setIdCarga(this.$route.params.id);

    if (this.cargas.dados.cargas.length > 0) {
      this.setCarga(
        this.cargas.dados.cargas.find((c) => c.id == this.id_carga)
      );
      await this.buscarVeiculo();
    }

    this.carregando = false;
  },
};
</script>
